import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { Button, Typography } from '@mui/material';
import { BackdropLoader, toast } from '@livable/saas-react-components';
import NotesTexfield from 'src/components/shared/NotesTexfield';
import { useStore } from 'src/stores';
import useStyles from '../styles';
export const NotesTab = observer(_ref => {
  let residencyId = _ref.residencyId;
  const store = useStore();
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    asyncNotes = _useState2[0],
    setAsyncNotes = _useState2[1];
  const _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    currentNotes = _useState4[0],
    setCurrentNotes = _useState4[1];
  const handleSubmit = async () => {
    const data = {
      residencyId: residencyId,
      notes: currentNotes.trim()
    };
    const resp = await store.residencies.updateResidencyNotesAsync.run(data);
    if (resp && resp.isSuccessful) {
      setAsyncNotes(currentNotes);
      toast('success', {
        body: ['Successfully saved']
      });
    }
  };
  useEffect(() => {
    const getResidencyNotesAsync = async data => {
      const resp = await store.residencies.getResidencyNotesAsync.run(data);
      return resp;
    };
    getResidencyNotesAsync({
      residencyId: residencyId
    }).then(async resp => {
      if (!resp) {
        return;
      }
      setAsyncNotes(resp.response.notes ? resp.response.notes : '');
      setCurrentNotes(resp.response.notes ? resp.response.notes : '');
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.tabWithFooter
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.content
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('unit_modal.notes_regarding_resident')), /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(NotesTexfield, {
    label: t('unit_modal.add_notes_here'),
    value: currentNotes,
    onChange: setCurrentNotes
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.footer
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    onClick: handleSubmit,
    disabled: asyncNotes === currentNotes,
    'custom-attribute': '256-notes-tab'
  }, t('buttons.save_changes'))), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: store.residencies.getResidencyNotesAsync.inProgress || store.residencies.updateResidencyNotesAsync.inProgress
  }));
});